import bcryptjs from "bcryptjs";
import { keycloakUtils } from "src/itsf/keycloak/keycloakUtils";

export const addUserEmailHashToGTM = async () => {
    try {
        const userProfile = await keycloakUtils.getUserProfile();
        const email = userProfile?.email ?? "";

        if (email && process.env.GTM_EMAIL_SALT) {
            bcryptjs.hash(email, process.env.GTM_EMAIL_SALT, (err: Error, hash: string) => {
                if (err) {
                    throw new Error("Couldn't load user's information.");
                }
                global.dataLayer.push({ userId: hash });
            });
        }
    } catch (error) {
        throw new Error("Couldn't load user's information.");
    }
};
